import React, { useState, useEffect } from "react";
import config from "../config";
import "../styles/UpdateConcentration.css";

function UpdateConcentration() {
  const [data, setData] = useState([]);
  const [departmentName, setDepartmentName] = useState("");
  const [caConcentration, setCaConcentration] = useState("");
  const [alkConcentration, setAlkConcentration] = useState("");
  const [clConcentration, setClConcentration] = useState("");
  const [pConcentration, setPConcentration] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch existing concentration data
  const fetchConcentration = async () => {
    try {
      const url = `${config.apiUrl}/params/`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "SD-API-KEY": config.apiKey,
          "Content-Type": "application/json",
        },
        mode: "cors",
        credentials: "include",
        cache: "no-cache",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error("查询失败:", error);
    }
  };

  useEffect(() => {
    fetchConcentration();
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    setLoading(true);

    const payload = {
      department_name: departmentName,
      ca: caConcentration,
      alk: alkConcentration,
      cl: clConcentration,
      p: pConcentration,
    };

    try {
      const url = `${config.apiUrl}/params/`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "SD-API-KEY": config.apiKey,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
        mode: "cors",
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("更新成功:", result);
      setSuccessMessage("更新成功！"); // Set success message
      fetchConcentration(); // Refresh the data after update
    } catch (error) {
      console.error("更新失败:", error);
      setError("更新失败，请重试");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update-concentration">
      <h1>更新标液浓度</h1>
      <form onSubmit={handleSubmit} className="concentration-form">
        <div className="form-group">
          <label>化验室名称:</label>
          <input
            type="text"
            value={departmentName}
            onChange={(e) => setDepartmentName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>钙离子标液浓度 (mol/L):</label>
          <input
            type="text"
            value={caConcentration}
            onChange={(e) => setCaConcentration(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>碱度标液浓度 (mol/L):</label>
          <input
            type="text"
            value={alkConcentration}
            onChange={(e) => setAlkConcentration(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>氯离子标液浓度 (mol/L):</label>
          <input
            type="text"
            value={clConcentration}
            onChange={(e) => setClConcentration(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>总磷标液浓度 (mol/L):</label>
          <input
            type="text"
            value={pConcentration}
            onChange={(e) => setPConcentration(e.target.value)}
            required
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}
        <button type="submit" disabled={loading}>
          {loading ? "提交中..." : "提交"}
        </button>
      </form>

      <h2>当前标液浓度</h2>
      <table className="concentration-table">
        <thead>
          <tr>
            <th>化验室名称</th>
            <th>钙离子标液浓度 (mol/L)</th>
            <th>碱度标液浓度 (mol/L)</th>
            <th>氯离子标液浓度 (mol/L)</th>
            <th>总磷标液浓度 (mol/L)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.department_name}</td>
              <td>{item.ca}</td>
              <td>{item.alk}</td>
              <td>{item.cl}</td>
              <td>{item.p}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default UpdateConcentration;
